import type { PaletteTranslation } from './en';

/** Hindi. Pending review by native speakers, as the note in the interface says. */
export const paletteHi: PaletteTranslation = {
  open: 'पेज खोजें',
  button: 'खोजें',
  title: 'किसी पेज पर जाएँ',
  description:
    'वह पेज ढूँढने के लिए टाइप करें जिसे आप खोल सकते हैं। चुनने के लिए तीर कुंजियाँ, खोलने के लिए Enter दबाएँ।',
  placeholder: 'पेज का नाम लिखें, जैसे जानकारी या टीम और एक्सेस',
  empty: '“{{query}}” से कोई पेज मेल नहीं खाता।',
  emptyHint: 'कोई दूसरा शब्द आज़माएँ। केवल वही पेज दिखते हैं जिन्हें आप खोल सकते हैं।',
  current: 'आप यहाँ हैं',
  account: 'आपका खाता',
  hint: {
    move: 'चुनने के लिए',
    open: 'खोलने के लिए',
    close: 'बंद करने के लिए',
  },
};
